import { useMemo, type PropsWithChildren } from 'react';
import { useDecision } from '@optimizely/react-sdk';
import { useTrackOptimizely } from '@fff-web/fff-analytics';
import { GROWTH_UPGRADE_MEMBERSHIP } from '../../../utils/Optimizely/featureFlagVariations';
import { GrowthUpgradeType, UpgradeMembershipContext } from './UpgradeMembershipContext';

export const UpgradeMembershipProvider = ({ children }: PropsWithChildren) => {
  const [growthUpgradeDecision] = useDecision(GROWTH_UPGRADE_MEMBERSHIP.FEATURE_FLAG);

  useTrackOptimizely(growthUpgradeDecision, GROWTH_UPGRADE_MEMBERSHIP.EXPERIMENT_NAME);

  const memoizedValues = useMemo(
    () => ({
      growthUpgrade: growthUpgradeDecision as GrowthUpgradeType,
    }),
    [growthUpgradeDecision],
  );

  return (
    <UpgradeMembershipContext.Provider
      value={{
        ...memoizedValues,
      }}
    >
      {children}
    </UpgradeMembershipContext.Provider>
  );
};
